// Monthly cost baselines (in local currency) — demo estimates, not verified live figures.
export const countries = [
  { code: "GB", name: "United Kingdom", currency: "GBP", symbol: "£", idrRate: 19600 },
  { code: "AU", name: "Australia", currency: "AUD", symbol: "A$", idrRate: 10500 },
  { code: "EU", name: "Jerman (Eropa)", currency: "EUR", symbol: "€", idrRate: 17200 },
  { code: "JP", name: "Jepang", currency: "JPY", symbol: "¥", idrRate: 105 },
  { code: "US", name: "Amerika Serikat", currency: "USD", symbol: "$", idrRate: 16200 },
];

// Baseline monthly living cost per city at "Standard" lifestyle (local currency).
export const cities = {
  GB: [
    { name: "London", housing: 900, food: 300, transport: 160, personal: 200, utilities: 90, insurance: 60, tuitionYear: 22000 },
    { name: "Manchester", housing: 620, food: 260, transport: 90, personal: 170, utilities: 80, insurance: 60, tuitionYear: 19000 },
  ],
  AU: [
    { name: "Sydney", housing: 1600, food: 700, transport: 180, personal: 400, utilities: 150, insurance: 55, tuitionYear: 42000 },
    { name: "Melbourne", housing: 1400, food: 650, transport: 160, personal: 380, utilities: 140, insurance: 55, tuitionYear: 40000 },
  ],
  EU: [
    { name: "Berlin", housing: 750, food: 300, transport: 60, personal: 220, utilities: 120, insurance: 120, tuitionYear: 0 },
    { name: "Munich", housing: 950, food: 320, transport: 65, personal: 240, utilities: 130, insurance: 120, tuitionYear: 0 },
  ],
  JP: [
    { name: "Tokyo", housing: 80000, food: 45000, transport: 12000, personal: 30000, utilities: 12000, insurance: 3000, tuitionYear: 535800 },
    { name: "Osaka", housing: 60000, food: 40000, transport: 10000, personal: 25000, utilities: 11000, insurance: 3000, tuitionYear: 535800 },
  ],
  US: [
    { name: "New York", housing: 2000, food: 700, transport: 130, personal: 450, utilities: 150, insurance: 250, tuitionYear: 45000 },
    { name: "Boston", housing: 1800, food: 650, transport: 90, personal: 420, utilities: 140, insurance: 250, tuitionYear: 47000 },
  ],
};

export const lifestyleMultiplier = {
  Budget: 0.8,
  Standard: 1.0,
  "Higher Comfort": 1.35,
};

// One-time setup costs per country (local currency), demo estimates.
export const oneTimeCosts = {
  GB: { visa: 490, flight: 700, setup: 800 },
  AU: { visa: 710, flight: 1100, setup: 1500 },
  EU: { visa: 75, flight: 650, setup: 1200 },
  JP: { visa: 3000, flight: 90000, setup: 150000 },
  US: { visa: 185, flight: 900, setup: 1500 },
};
